import { SMALL_DEVICE_HEIGHT } from '../core/consts';

export const isSmallHeight = () => window.innerHeight < SMALL_DEVICE_HEIGHT;
